
export const CATEGORY_AVAILABILITY_GET_REQUEST = 'CATEGORY_AVAILABILITY_GET_REQUEST';
export const CATEGORY_AVAILABILITY_GET_SUCCESS = 'CATEGORY_AVAILABILITY_GET_SUCCESS';
export const CATEGORY_AVAILABILITY_GET_ERROR = 'CATEGORY_AVAILABILITY_GET_ERROR'; 

export const CATEGORY_AVAILABILITY_POST_REQUEST = 'CATEGORY_AVAILABILITY_POST_REQUEST';
export const CATEGORY_AVAILABILITY_POST_SUCCESS = 'CATEGORY_AVAILABILITY_POST_SUCCESS';
export const CATEGORY_AVAILABILITY_POST_ERROR = 'CATEGORY_AVAILABILITY_POST_ERROR';
